module.exports = __webpack_public_path__ + "img/icon-lottery-black.88a6987e.svg";